import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../Context";

export default function HTMLColors() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("HTML - Colors | Aspirant's Home");
        const urls = {
            'previous': '/html/comments',
            'next': '/html/images'
        }
        path.setPreviousNext(urls);
    }, [])

    return (
        <section className='mt-5 mb-5'>
            <h3>HTML - Colors</h3>
            <div className='mt-4 mb-5'>

            </div>
        </section>
    )
}